import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ObjectionSection() {
  return <section className="py-16 bg-stone-100 border-y border-stone-200" data-id="element-98">
      <div className="max-w-2xl mx-auto px-4 text-center" data-id="element-99">
        <h3 className="text-2xl font-bold text-gray-800 mb-8 uppercase tracking-wider" data-id="element-100">
          Este libro{' '}
          <span className="text-red-600 underline decoration-2 underline-offset-4" data-id="element-101">
            no es
          </span>
          :
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-102">
          {['autoayuda vacía', 'frases motivacionales', 'recetas mágicas', 'exigencias de “pensar positivo”'].map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: idx * 0.1
        }} viewport={{
          once: true
        }} className="flex items-center gap-3 bg-white p-4 rounded shadow-sm" data-id="element-103">
              <X className="text-red-600 w-6 h-6 flex-shrink-0" strokeWidth={3} data-id="element-104" />
              <span className="text-gray-700 font-medium text-left" data-id="element-105">
                {item}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-106">
          <p className="text-lg text-gray-600" data-id="element-107">
            No te dice qué hacer. No te empuja. No te juzga.
          </p>

          <p className="text-3xl md:text-4xl font-serif font-bold text-gray-900" data-id="element-108">
            Te acompaña.
          </p>
        </motion.div>
      </div>
    </section>;
}